export const utmMediumIconMap = {
  organic: 'icon-medium-organic',
  default: 'icon-source-default',
  '(none)': 'icon-empty-circle',
};

export const utmMediumSvgMap = {
  referral: 'Link',
  referredby: 'Marketing',
  'referred by': 'Marketing',
  organic: 'Search',
  'cost per click': 'Money',
  cpc: 'Money',
  email: 'At',
  social: 'SocialAlt',
};

export const utmSourceIconMap = {
  bing: 'icon-bing',
  facebook: 'icon-facebook',
  '(direct)': 'icon-source-direct',
  google: 'icon-google',
  gmb: 'icon-gmb',
  GMBlisting: 'icon-gmb',
  'Google My Business': 'icon-gmb',
  instagram: 'icon-instagram',
  'instagram.com': 'icon-instagram',
  linkedin: 'icon-linkedin',
  mailchimp: 'icon-mailchimp',
  pinterest: 'icon-pinterest',
  twitter: 'icon-twitter',
  yelp: 'icon-yelp',
  youtube: 'icon-youtube',
  realself: 'icon-realself',
  yahoo: 'icon-yahoo',
  default: 'icon-source-default',
  '(none)': 'icon-empty-circle',
};

export const utmSourceSvgMap = {
  '(direct)': 'Target',
};

export const utmSourceIconMapInsensitive = Object.fromEntries(Object.entries(utmSourceIconMap).map(([key, value]) => [key.toLowerCase(), value]));
export const utmSourceSvgMapInsensitive = Object.fromEntries(Object.entries(utmSourceSvgMap).map(([key, value]) => [key.toLowerCase(), value]));
